import { Component, OnInit } from '@angular/core';
import { PostService } from '../../services/post.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { Post } from '../../models/post.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-posts',
  standalone: true,
  imports: [MatCardModule, MatButtonModule, CommonModule],
  templateUrl: './posts.component.html',
  styleUrl: './posts.component.scss',
})
export class PostsComponent implements OnInit {
  posts: Post[] = [];

  showComments: boolean = false;
  commentSectionPostId: string = '';
  constructor(private postService: PostService) {}

  ngOnInit(): void {
    this.postService.getAllPosts().subscribe({
      next: (response) => {
        this.posts = response;
      },
    });
  }

  viewComments(postId: string) {
    this.showComments = !this.showComments;

    if (this.commentSectionPostId != postId) {
      this.commentSectionPostId = postId;
      this.showComments = true;
    }
  }
}
